/**
 * Cookie name to use for CSRF token storage
 * @type {string}
 */
const COOKIE_NAME = 'csrftoken';

/**
 * HTTP header to use for CSRF token
 * @type {string}
 */
const CSRF_HEADER = 'X-CSRFToken';

const mod = angular.module('django_csrf_intercept', [])

.config(function($httpProvider) {
  $httpProvider.defaults.xsrfCookieName = COOKIE_NAME;
  $httpProvider.defaults.xsrfHeaderName = CSRF_HEADER;
})

;

export default mod.name;



// WEBPACK FOOTER //
// ./src/common/django-csrf-intercept/django_csrf_intercept.module.js